import React from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { Container } from '../../components';

import styles from './styles.module.css';
const index = () => {
  return (
    <div className={styles.container}>
      <Container>
        <div className={styles.inner}>
          <Row>
            <Col lg={3} xs={12}>
              <div>
                <img src={'./assets/images/deals1.jpg'} width="282px" alt={'travel-offer'} />
              </div>
            </Col>
            <Col lg={9} xs={12}>
              <div className={styles.content}>
                <div>
                  <div className={styles.title}>Umrah Guide</div>
                  <p className={styles.text}>Enjoy 15% or more off stays between now and January 4, 2021.</p>
                </div>
                <a href="/" className={styles.button}>See Deals</a>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default index;
